/**
 * Matches audience names separated by ','. Captures the following information:
 * [0]: whole match starting
 * index: 0-based index of the whole match within the parsed string
 */
export const audienceListSyntax = /(?:[^,\\]|\\\S)+/ig;
